import { SVGProps } from 'react';

export const DownloadIcon = (props?: SVGProps<SVGSVGElement> & { title?: string }) => {
  return (
    <svg width="15" height="15" viewBox="-4 -4 173 173" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {props?.title && <title>{props.title}</title>}
      <path
        d="M158 119V138C158 149.046 149.046 158 138 158H27C15.9543 158 7 149.046 7 138V119"
        stroke="currentColor"
        strokeWidth="14"
        strokeLinecap="round"
      />
      <path d="M82 97.4998V7" stroke="currentColor" strokeWidth="14" strokeLinecap="round" />
      <path
        d="M75.6866 118.427C78.8104 123.504 86.1896 123.504 89.3134 118.427L110.072 84.6925C113.351 79.3624 109.517 72.5 103.258 72.5H61.7419C55.4834 72.5 51.6486 79.3624 54.9284 84.6925L75.6866 118.427Z"
        fill="currentColor"
      />
    </svg>
  );
};
